<!-- eslint-disable vue/no-deprecated-slot-scope-attribute -->
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All Orders</h5>
                <p class="mb-0 text-sm">
                  Below the list of orders.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="row">
                  <div class="col">
                    <div class="my-auto ms-auto">
                      <button
                      class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                      :class="{'disabled': exportLoading}"
                      @click="onClickExport()"
                    >
                      Export <i v-if="exportLoading" class="fas fa-spinner fa-pulse"></i>
                    </button>
                    
                    <download-excel
                      ref="btnExport"
                      class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0 d-none"
                      :data="recordsForExport"
                      :fields="json_fields"
                      worksheet="My Worksheet"
                      name="orders.xls"
                    >
                      Export
                    </download-excel>
                  </div>
                </div>                
                </div>                
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <div class="row">
                        <div class="col-5">
                          <div class="input-daterange datepicker row align-items-center" >
                            <base-input addon-left-icon="ni ni-calendar-grid-58" >
                            <date-range-picker
                                ref="picker"
                                :opens="opts.opens"
                                :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"
                                :singleDatePicker="opts.singleDatePicker"
                                :showWeekNumbers="opts.showWeekNumbers"
                                :showDropdowns="opts.showDropdowns"
                                :autoApply="opts.autoApply"
                                :dateRange="opts.dateRange"
                                v-model="dates.range"
                                :linkedCalendars="opts.linkedCalendars"
                              >
                                <template v-slot:input="picker" style="min-width: 350px;">
                                    {{ dateTime(picker.startDate) }} - {{ dateTime(picker.endDate) }}
                                </template>
                              </date-range-picker>
                            </base-input>
                          </div>
                      
                        </div>
                        <div class="col-2">
                          <select class="dataTable-selector form-select form-select-sm" v-model="filter_by">
                            <option value="" disabled hidden>Search By</option>
                            <option v-for="item in filterOpts" :value="item.value" :key="item.label" >{{ item.label }}</option>                        
                          </select>          
                        </div>
                        <div class="col-3">
                          <input class="dataTable-input form-control" placeholder="Search..." type="text" v-model="search">
                        </div>
                        <div class="col">                                          
                          <button class="rounded btn btn-xs text-white bg-success" @click="getAllAPI()">
                            <i class="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            Order ID
                          </th>
                          <th>
                            Order Title
                          </th>
                          <th>
                            Customer Code
                          </th>
                          <th>
                            Customer Name
                          </th>
                          <th>
                            Total Amount
                          </th>
                          <th>
                            Status
                          </th>
                          <th>
                            Updated At
                          </th>                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ ((this.currentPage-1)*this.limitPerPage) + index+1 }}</td>
                          <td class="text-sm">{{ record.id }}</td>
                          <td class="text-sm">{{ record.order_title }}</td>
                          <td class="text-sm">{{ record.customer_code }}</td>
                          <td class="text-sm">{{ record.customer_name }}</td>
                          <td class="text-sm">Rp{{ record.payment_amount || 0 }}</td>
                          <td>
                            <span class="badge badge-danger badge-sm" v-if="record.status == 'declined'">Declined</span>
                            <span class="badge badge-danger badge-sm" v-else-if="record.status == 'expired'">Expired</span>
                            <span class="badge badge-info badge-sm" v-else-if="record.status == 'pending'">Pending</span>
                            <span class="badge badge-warning badge-sm" v-else-if="record.status == 'waiting_confirmation'">Waiting Confirmation</span>
                            <span class="badge badge-success badge-sm" v-else-if="record.status == 'paid'">Paid</span>
                          </td>
                          <td class="text-sm">{{ dateTime(record.updated_at) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<style>
  .vue-daterange-picker .form-control.reportrange-text{
    padding: 0.5rem 0.75rem !important;    
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border: 1px solid #ccc !important;
  }
  .vue-daterange-picker {
    width: 85%;
  }
  .input-daterange.datepicker .form-group.input-group {
    margin-right:50px;
  }
</style>
  <script>
  import OrderService from "@/services/orders.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import BaseInput from "@/components/BaseInput.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';
  import JsonExcel from "vue-json-excel3";
  import DateRangePicker from 'vue3-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  //you need to import the CSS manually


  const toastId = ref('');

  const moment = require('moment');

  export default {
    name: "ExternalUserList",
    data() {
      let startDate = new Date();
      let endDate = new Date();
      startDate.setDate(startDate.getDate() - 7)
      
      return {
        filterOpts: [{label: 'Invoice', value: 'id'}, {label: 'Customer Code', value: 'customer_code'}],

        opts: {
          dateRange: {startDate,endDate},
          opens: "left",
          minDate: new Date(),
          maxDate: new Date(),
          singleDatePicker: false,
          showWeekNumbers: true,
          autoApply: false,
          linkedCalendars: true,
        },
        dates: {
            range: {startDate: startDate, endDate: endDate}
          },
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        search: '',
        filter_by: '',
        sortBy: {
          name: 'updated_at',
          sortType: '-1'
        },
        json_fields: {
            "ID": "id",
            "Order Title": "order_title",
            "Customer Code": "customer_code",
            "Customer Name": "customer_name",
            "Total Amount": "payment_amount",
            "Status": "status",
            "Updated At": "updated_at",            
          },
        recordsForExport: [],
        exportLoading: false 
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      onClickExport(){
        this.exportLoading = true
        this.showLoading()

        const params = {
          limit: 1000,
          page: 1,
          filter: this.search,
          filter_by: this.filter_by,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        OrderService.getAll(params).then(e => {
          this.hideLoading()
          this.exportLoading = false

          const data = e.data
          this.recordsForExport = data.orders
          if(this.recordsForExport != null && this.recordsForExport.length > 0 ){
            this.$refs.btnExport.$el.click()
          }

        })
      },
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(){
        toast.update(toastId.value, {
          render: "delete Successfully",
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      confirmationDelete(id){
        this.showSwalConfirmationDelete().then((result) => {
            console.log(result)
            if (result.value) {
              this.deleteRecord(id)
            }
          });        
      },
      deleteRecord(id){
        this.showLoading()

        OrderService.delete(id).then(() => {
          this.showSuccess()
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      dateTimeV2(value) {
        return moment(value).format("YYYY-MM-DD");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        const params = {
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search,
          filter_by: this.filter_by,
          date_start: this.dateTimeV2(this.dates.range.startDate),
          date_end: this.dateTimeV2(this.dates.range.endDate)
        }
        params[`sort_by[${this.sortBy.name}]`] = `${this.sortBy.sortType}`

        OrderService.getAll(params).then(e => {
          const data = e.data
          this.records = data.orders
          this.totalRecords = data.count
        })
      },      
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      BaseInput,
      DateRangePicker,
      downloadExcel:JsonExcel

    },
    mounted() {
      this.getAllAPI()
    },
  };
  </script>
  